import React from "react";
import { Feather as Icon } from 'react-web-vector-icons';
import { ActivityIndicator } from "../loading/ActivityIndicator";

export const IconButton = ({ icon, loading, text, onPress }) => {
  return (
    <div className="iconButton" onClick={() => onPress ? onPress() : null}>
      {loading ? <ActivityIndicator /> : (
        <React.Fragment>
          <Icon name={icon} color='var(--onPrimary)' size={20} />
          <span>{text}</span>
        </React.Fragment>
      )}
    </div>
  )
}